import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Container,
  FormControl,
  FormHelperText,
  Grid,
  InputAdornment,
  OutlinedInput,
  Snackbar,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import PersonIcon from "@mui/icons-material/Person";
import { useDispatch, useSelector } from "react-redux";
import { sendOTP } from "../redux/actions/AdminAction";
import { useNavigate } from "react-router-dom";

export default function ForgotPassword() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [emailError, setEmailError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const emailInputRef = useRef();

  const SendOTPData = useSelector((state) => state.SendOTPData);
  const { sendOTPerror, sendOTPInfo } = SendOTPData;

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  useEffect(() => {
    if (sendOTPInfo) {
      navigate("/changepassword");
    }
  }, [sendOTPInfo]);

  const handleEmailValidation = (email) => {
    setEmailError(!emailRegex.test(email));
  };

  const handleSendOTP = (e) => {
    e.preventDefault();
    setSnackOpen(true);
    const requestData = { email: emailInputRef.current.value, from: 'forgot_password' };
    dispatch(sendOTP(requestData));
  };

  const handleSnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackOpen(false);
  };

  return (
    <Container sx={{ marginBottom: "5%" }}>
      <Box
        sx={{
          mt: 10,
        }}
      >
        <Grid container spacing={3} sx={{ textAlign: "center" }}>
          <Grid xs={12}>
            <Typography
              sx={{
                fontSize: 30,
                textAlign: "center",
                ml: 3,
                color: "#313639",
              }}
            >
              Forgot Password
            </Typography>
          </Grid>
          <Grid item xs={12} sx={{ textAlign: "center", marginTop: 3 }}>
            <FormControl
              variant="outlined"
              size="medium"
              error={emailError}
              sx={{ width: "35%" }}
            >
              <OutlinedInput
                required
                sx={{ height: "8vh" }}
                placeholder="Email"
                name="email"
                inputRef={emailInputRef}
                onChange={(e) => handleEmailValidation(e.target.value)}
                endAdornment={
                  <InputAdornment position="end">
                    <PersonIcon />
                  </InputAdornment>
                }
              />
              {emailError && (
                <FormHelperText error>Invalid email format</FormHelperText>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={12} sx={{ fontSize: 40, textAlign: "center" }}>
            <Typography
              sx={{
                textAlign: "center",
                color: "#313639",
              }}
            >
              OTP will be sent to you registered email
            </Typography>
          </Grid>
          <Grid item xs={12} sx={{ fontSize: 40, textAlign: "center" }}>
            <Button
              type="submit"
              onClick={handleSendOTP}
              size="small"
              sx={{
                backgroundColor: "#282828",
                border: "1px solid #313639",
                color: "#ffffff",
                width: "35vh",
                height: "8vh",
                mt: 1,
                fontSize: 18,
                "&:hover": {
                  backgroundColor: "#282828",
                  color: "#ffffff",
                },
              }}
            >
              Send OTP
            </Button>
          </Grid>
          {sendOTPerror && (
            <Snackbar
              open={snackOpen}
              autoHideDuration={5000}
              onClose={handleSnackClose}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              sx={{ width: "20%" }}
            >
              <Alert
                onClose={handleSnackClose}
                severity="error"
                sx={{ width: "100%" }}
              >
                <AlertTitle>Error</AlertTitle>
                {sendOTPerror}
              </Alert>
            </Snackbar>
          )}
        </Grid>
      </Box>
    </Container>
  );
}
